import React, { ReactElement } from "react";

function Home(): ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 29 32">
            <path d="M1.996 30.156h6.752L8.743 19.63h11.205v10.666l6.667-.027V14.112l-12.309-11.4-12.31 11.239v16.205zM10.745 32H0V13.07L14.316 0l14.295 13.24V32H17.952V21.625h-7.211L10.746 32z"></path>
        </svg>
    );
}

export default Home;
